//import ProductHelpers from '../product/base';
import { getPidValue } from '../product/helpers/baseHelpers';

const getAddToCartUrl = () => {
    return $('.add-to-cart-url').val();
};

class GiftcardHelpers {
    addToCart () {
        $('body').on('click', 'button.giftcard-add-to-cart-global', e => {
            e.preventDefault();

            // Validate price
            let amountSelectorOk = true;
            if ($('.js-amount-selector.active').length === 0 || $('.js-amount-selector.active').attr('data-amount') === '0' || $('.js-amount-selector.active').attr('data-amount') === '0.0' || $('.js-amount-selector.active').attr('data-amount') == 0) {
                $('.js-price-validation-error-not-selected').removeClass('hidden');
                if ($('.js-typeAmount').length > 0) {
                    $('.js-typeAmount').addClass('is-invalid-input');
                }
                amountSelectorOk = false;
            }

            let errors = [];
            let container = $('.parsleyValidatableElement');
            for (let i = 0; i < container.length; i++) {
                let validator = container.eq(i).parsley();
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                }
            }

            if (errors.length > 0 || !amountSelectorOk) {
                return;
            }

            let pid = getPidValue($(e.currentTarget));
            let addToCartUrl = getAddToCartUrl();
            if (!addToCartUrl) {
                return;
            }

            let uid = $(e.currentTarget).data('uid');

            let country = $('#countrySelector').val();
            let destinationName = $('.js-giftcardNameTo').val();
            let destinationMail = $('#giftcard--mail-to').val();
            let senderName = $('.js-giftcardYourName').val();
            let message = $('#contact-form-message').val() || '';
            let amount = $('.js-amount-selector.active').attr('data-amount');
            let dateString = $('.datepickerTriggerElement').data('date');

            let imgCodes = $('.js-ImgGiftCard.slick-current img:not(.lazyload)').attr('data-src').split('/');
            let imgCode = imgCodes[imgCodes.length - 1].replace('.jpg', '');
            var form = {
                pid: pid,
                quantity: 1,
                uuid: uid,
                destinationName: destinationName,
                destinationMail: destinationMail,
                message: message,
                senderName: senderName,
                amount: amount,
                shippingDate: dateString,
                country: country,
                imageCode: imgCode
            };
            // Chosen select
            if (Foundation.MediaQuery.atLeast('medium')) {
                $('select.select-chosen').chosen({disable_search: true});
            }
            if (addToCartUrl) {
                const $emailInput = $('#giftcard--mail-to');
                const $errorDiv = $emailInput.parent().siblings('.invalid-feedback');
                $.spinner().start();
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: data => {
                        $('body').trigger('product:afterAddToCartGiftCard', data);
                        $('.minicart').trigger('count:update', data);
                        $.spinner().stop();
                    },
                    error: () => {
                        $emailInput.addClass('is-invalid');
                        $errorDiv.addClass('is-visible');
                        $.spinner().stop();
                    }
                });
            }
        });
    }
}

const giftcardHelper = new GiftcardHelpers();
export default giftcardHelper;
